import React from 'react';

const SvgWithoutPay = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="13"
    viewBox="0 0 16 13"
    fill="none"
    {...props}
  >
    <path
      d="M3.89911 3.27172C3.98391 3.04205 4.09616 2.8241 4.23085 2.62021L1.07555 0.330548C0.915916 0.215713 0.688934 0.243836 0.564219 0.39148L0.0753348 0.986746C-0.0468863 1.13673 -0.0169546 1.35 0.140187 1.46718L3.71952 4.06385C3.74446 3.79434 3.80432 3.52951 3.89911 3.27172Z"
      fill="currentColor"
    />
    <path
      d="M15.8593 11.0524L12.2775 8.45569C12.2525 8.72754 12.1927 8.99939 12.0929 9.26656C12.0106 9.4892 11.9008 9.70012 11.7662 9.89698L14.9264 12.189C15.0861 12.3038 15.3131 12.2757 15.4378 12.1281L15.9267 11.5351C16.0464 11.3828 16.0165 11.1672 15.8593 11.0524Z"
      fill="currentColor"
    />
    <path
      d="M9.62644 5.73008L6.93234 4.98945C6.62052 4.90508 6.40349 4.63086 6.40349 4.32617C6.40349 3.94414 6.73277 3.63477 7.13938 3.63477H8.79326C9.0976 3.63477 9.39694 3.72148 9.6464 3.88086C9.79857 3.97695 10.0031 3.95352 10.1328 3.83398L11.0009 3.03711C11.178 2.87539 11.1531 2.60586 10.956 2.46289C10.3449 2.01289 9.58154 1.76211 8.79825 1.75977V0.634766C8.79825 0.428516 8.61865 0.259766 8.39913 0.259766H7.60087C7.38135 0.259766 7.20175 0.428516 7.20175 0.634766V1.75977H7.13938C5.55036 1.75977 4.27315 3.0418 4.42033 4.56289C4.5251 5.64336 5.40318 6.52227 6.51076 6.82695L9.06766 7.53008C9.37948 7.6168 9.59651 7.88867 9.59651 8.19336C9.59651 8.57539 9.26723 8.88477 8.86062 8.88477H7.20674C6.9024 8.88477 6.60306 8.79805 6.3536 8.63867C6.20143 8.54258 5.99688 8.56602 5.86717 8.68555L4.99906 9.48242C4.82195 9.64414 4.8469 9.91367 5.04397 10.0566C5.65513 10.5066 6.41846 10.7574 7.20175 10.7598V11.8848C7.20175 12.091 7.38135 12.2598 7.60087 12.2598H8.39913C8.61865 12.2598 8.79825 12.091 8.79825 11.8848V10.7551C9.96071 10.734 11.0508 10.0848 11.435 9.05117C11.9713 7.60742 11.0708 6.12617 9.62644 5.73008Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgWithoutPay;
